<template>
  <div class="slot-inspector-status-tag-group">
    <SlotInspectorStatusTag
      v-for="action in actionsWithSlots"
      :key="action.key"
      :action="action.key"
      :count="action.count"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { ACTIONS } from "#ce/apps/SpAdmin/SpSlotInspectorApp/actions";
import SlotInspectorStatusTag from "./SlotInspectorStatusTag.ce.vue";

const props = defineProps({
  /**
   * Slots per action, keyed by the payload's action names. Actions without slots get no tag.
   */
  counts: {
    type: Object,
    default: () => ({}),
  },
});

const actionsWithSlots = computed(() =>
  ACTIONS.filter((action) => props.counts[action.key] > 0).map((action) => ({
    key: action.key,
    count: props.counts[action.key],
  })),
);
</script>

<style scoped lang="scss">
.slot-inspector-status-tag-group {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-ref-scale-6);
}
</style>
